var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{staticStyle:{"margin-left":"20px"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:item.id,attrs:{"separator":">","to":{
      path: item.path
    }}},[_vm._v("\n      "+_vm._s(item.name))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }